import { Chip } from '@mui/material';
import React from 'react';

function CommonFilterChips({ selectedFilters = {}, onRemoveFilter, isShowGroupName = false, t }) {
  return Object.entries(selectedFilters).map(([groupName, options]) =>
    options.map((option) => (
      <Chip
        key={`${groupName}${option.value}-chip`}
        label={getChipLabel(option, groupName, isShowGroupName, t)}
        variant='outlined'
        onDelete={() => onRemoveFilter(groupName, option)}
        size='small'
        sx={{
          height: 'auto',
          '& .MuiChip-label': {
            display: 'block',
            whiteSpace: 'normal',
            color: 'var(--text-default)',
          },
          '& .MuiChip-deleteIcon': {
            color: 'var(--text-default)',
            transition: 'color 0.2s ease',

            '&:hover': {
              color: 'var(--text-stressed)',
            },
          },
        }}
      />
    )),
  );
}

export default CommonFilterChips;

const getChipLabel = (option, groupName, isShowGroupName = false, t) => {
  const coreLabel = option?.label || option;
  if (isShowGroupName) {
    return `${t(groupName)}: ${coreLabel}`;
  }
  return coreLabel;
};
